import End from "./scenes/end/End";
import Game from "./scenes/game/Game";
import Intro from "./scenes/intro/Intro";

export default {
    /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
    scenes: [Intro, Game, End],

    /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
    startScene: Intro.KEY,

    right: [
        "Nice job!",
        "Nice!{happy}",
        "Perfect!",
        "Outstanding!",
        "Wonderful!",
        "Awesome!",
        "Perfect!",
        "Impressive!",
        "Superb!{happy}",
        "You got it!",
        "That's right!",
        "You're good at this!",
        "Correct!{happy}",
        "You got that right!",
        "Great, you got it!",
        "Oh yeah! You got it.",
        "Yup! That was the right answer."
    ],
    wrong: [
        "Nope. Try again.{sad}",
        "Not quite. You should give it another go!",
        "Not that one.{sad}",
        "Not exactly, try again!",
        "That doesn't work.{sad}",
        "Unfortunately no. But I'm sure you'll get it next time!",
        "Nope, but I believe in you!",
        "That's not it, but keep going!",
        "No, but keep trying!",
        "You didn't get it right, but I believe in you!",
        "No, but I'm sure you'll get it!",
        "Not correct.{sad}",
        "That's not right",
        "Oops, not that one.",
        "That's a no-go, let's try it again!"
    ],
    emojis: [
        "Apple", "Bag", "Book", "Brain", "Cake", "Cat", "CheckMark", "Clock", "Cow", "Crocodile", "CryingEye", "Date", "Dog", "Dollar", "DownArrow", "Earth",
        "Egg", "Eye", "Feather", "Fish", "Flame", "Footprint", "Fork", "Gavel", "Gift", "Hat", "Horse", "LoafOfBread", "Milk", "MouthWithTongue", "OpenMouth",
        "PaintPalette", "Pajamas", "Potato", "Salt", "Shamrock", "Shirt", "Sleep", "Snowflake", "Speak", "StormCloud", "Sun", "Table", "Trophy", "Turkey",
        "TurnSign", "UpArrow", "WaterDrop", "Wings", "Wolf"
    ],
    groups: [
        [
           {
                name: "Under the weather",
                emojis: ["DownArrow", "Sun"],
                banned_emojis: ["StormCloud", "Snowflake"],
                correct_definition: "To be unwell or in low spirits.",
                incorrect_definitions: ["To have a short, light sleep; to doze.", "When someone has nothing to say."],
                sentence: "Lola did not go to school today because she was feeling ____ .",
                correct_idiom: "under the weather",
                incorrect_idioms: ["time flies", "the best of both worlds"]
            }, {
                name: "Time flies",
                emojis: ["Clock", "Wings"],
                banned_emojis: ["Date"],
                correct_definition: "Used to observe that time seems to pass very quickly.",
                incorrect_definitions: ["To be upset about something that cannot be changed, or that is not really a big deal.", "To reveal a secret carelessly or by mistake."],
                sentence: "Mya can't believe the day is already over. ____ when you are having fun.",
                correct_idiom: "Time flies",
                incorrect_idioms: ["Cat nap", "Under the weather"]
            }, {
                name: "Cry over spilt milk",
                emojis: ["CryingEye", "Milk"],
                banned_emojis: ["WaterDrop"],
                correct_definition: "To be upset about something that cannot be changed, or that is not really a big deal.",
                incorrect_definitions: ["To reveal a secret carelessly or by mistake.", "Used to show enthusiasm about a new idea, person or thing."],
                sentence: "Ana felt sad about her broken crayon, but she wasn't upset. She knows not to ____ .",
                correct_idiom: "cry over spilt milk",
                incorrect_idioms: ["take a cat nap", "be the best of both worlds"]
            }, {
                name: "Let the cat out of the bag",
                emojis: ["Cat", "Bag"],
                banned_emojis: [],
                correct_definition: "To reveal a secret carelessly or by mistake.",
                incorrect_definitions: ["Used to show enthusiasm about a new idea, person or thing.", "Used to say that you cannot do or have two good things at the same time."],
                sentence: "Carlos told Isabel about her surprise birthday party. He really ____ .",
                correct_idiom: "let the cat out of the bag",
                incorrect_idioms: ["took a cat nap", "was the best of both worlds"]
            }
        ], [
            {
                name: "The best thing since sliced bread",
                emojis: ["Trophy", "LoafOfBread"],
                banned_emojis: [],
                correct_definition: "Someone or something is the best thing invented in a long time.",
                incorrect_definitions: ["Used to say that you cannot do or have two good things at the same time.", "You shouldn't decide the value of something by its outward appearance."],
                sentence: "Emma loves her new toy. She thinks it's ____ .",
                correct_idiom: "the best thing since sliced bread",
                incorrect_idioms: ["a fish out of water", "going down in flames"]
            }, {
                name: "You can't judge a book by its cover",
                emojis: ["Gavel", "Book"],
                banned_emojis: [],
                correct_definition: "You shouldn't decide the value of something by its outward appearance.",
                incorrect_definitions: ["Everyone will have good luck or success at some point in their lives.", "Avoid interfering in a situation that is currently causing no problems."],
                sentence: "The teacher always looked mean but she was actually very nice. It just shows that you can't ____ .",
                correct_idiom: "judge a book by its cover",
                incorrect_idioms: ["let sleeping dogs lie", "put your foot in your mouth"]
            }, {
                name: "Let sleeping dogs lie",
                emojis: ["Dog", "Sleep"],
                banned_emojis: ["Pajamas"],
                correct_definition: "Avoiding an argument, or not interfering in a situation.",
                incorrect_definitions: ["Time is a valuable resource, therefore it is better to do things as quickly as possible.", "To withdraw suddenly and completely from something you are dependent on."],
                sentence: "Angelo really wanted to argue his point, but chose to remain quiet and ____ .",
                correct_idiom: "let sleeping dogs lie",
                incorrect_idioms: ["judge a book by its cover", "put her foot in her mouth"]
            }, {
                name: "To go cold turkey",
                emojis: ["Snowflake", "Turkey"],
                banned_emojis: [],
                correct_definition: "To suddenly stop a habit.",
                incorrect_definitions: ["To call for help when it is not needed.", "To be uncomfortable in a certain situation."],
                sentence: "Starting right now I will no longer eat meat. I am going to quit and ____ .",
                correct_idiom: "go cold turkey",
                incorrect_idioms: ["cry wolf", "be a fish out of water"]
            }, {
                name: "To cry wolf",
                emojis: ["CryingEye", "Wolf"],
                banned_emojis: ["WaterDrop"],
                correct_definition: "To call for help when it is not needed.",
                incorrect_definitions: ["To be uncomfortable in a certain situation.", "Used to describe an event that is a huge failure."],
                sentence: "The little girl ____ so many times that no one believed her when she was really sick.",
                correct_idiom: "cried wolf",
                incorrect_idioms: ["let sleeping dogs lie", "was the best thing since sliced bread"]
            }, {
                name: "A fish out of water",
                emojis: ["Fish", "WaterDrop"],
                banned_emojis: ["CryingEye"],
                correct_definition: "To be uncomfortable in a certain situation.",
                incorrect_definitions: ["Used to describe an event that is a huge failure.", "To say or do something embarrassing or inappropriate."],
                sentence: "Gerald did not like his new school. He felt like a ____ .",
                correct_idiom: "fish out of water",
                incorrect_idioms: ["going cold turkey", "the best thing since sliced bread"]
            }, {
                name: "Going down in flames",
                emojis: ["DownArrow", "Flame"],
                banned_emojis: ["Sun"],
                correct_definition: "Used to describe an event that is a huge failure.",
                incorrect_definitions: ["To say or do something embarrassing or inappropriate.", "To get information from the person who said it first."],
                sentence: "At first Manuel's team was on a winning streak, but then he began to lose each game. His career was ____ .",
                correct_idiom: "going down in flames",
                incorrect_idioms: ["going to cry wolf", "going cold turkey"]
            }, {
                name: "Put your foot in your mouth ",
                emojis: ["Footprint", "OpenMouth"],
                banned_emojis: ["MouthWithTongue"],
                correct_definition: "To say or do something embarrassing or inappropriate.",
                incorrect_definitions: ["To get information from the person who said it first.", "An achievement to be proud of."],
                sentence: "Anika really ____ when she mentioned the party to Sally, since Sally was not invited.",
                correct_idiom: "put her foot in her mouth",
                incorrect_idioms: ["let sleeping dogs lie", "cried wolf"]
            }
        ], [
            {
                name: "A feather in one's cap",
                emojis: ["Feather", "Hat"],
                banned_emojis: [],
                correct_definition: "Refers to an achievment that you are proud of.",
                incorrect_definitions: ["Used to describe a cherished person or thing.", "Used to describe an event that happens right away, or quickly."],
                sentence: "	Eli is very proud about being named Student of the Month. It is a real ____ .",
                correct_idiom: "feather in his cap",
                incorrect_idioms: ["hot potato", "food for thought"]
            }, {
                name: "At the drop of a hat",
                emojis: ["WaterDrop", "Hat"],
                banned_emojis: ["DownArrow"],
                correct_definition: "Used to describe an event that happens right away, or quickly.",
                incorrect_definitions: ["A view of something from above.", "A controversial issue or situation."],
                sentence: "Olivia is dressed and ready to go hiking. She can leave ____ !",
                correct_idiom: "at the drop of a hat",
                incorrect_idioms: ["straight from the horse's mouth", "in hot water"]
            }, {
                name: "A bird's eye view",
                emojis: ["Turkey", "Eye"],
                banned_emojis: ["CryingEye"],
                correct_definition: "A view of something from above.",
                incorrect_definitions: ["A controversial issue or situation.", "To be nervous about something and want to avoid it."],
                sentence: "The students climbed the highest tower so that they could have a ____ of the city.",
                correct_idiom: "bird's eye view",
                incorrect_idioms: ["dog days of summer", "lucky dog"]
            }, {
                name: "To have cold feet ",
                emojis: ["Snowflake", "Footprint"],
                banned_emojis: [],
                correct_definition: "To be nervous about something and want to avoid it.",
                incorrect_definitions: ["Faking tears when you are not actually upset.", "Very hot days."],
                sentence: "Marco refused to go on stage during his performance. He had ____ .",
                correct_idiom: "cold feet",
                incorrect_idioms: ["a feather in his cap", "food for thought"]
            }, {
                name: "Crocodile Tears",
                emojis: ["Crocodile", "CryingEye"],
                banned_emojis: ["WaterDrop"],
                correct_definition: "Faking tears when you are not actually upset.",
                incorrect_definitions: ["Very hot days.", "To be in trouble."],
                sentence: "Even though Xavier was crying, his teacher knew he was not hurt; he was crying ____ .",
                correct_idiom: "crocodile tears",
                incorrect_idioms: ["in hot water", "straight from the horse's mouth"]
            }, {
                name: "Food for thought ",
                emojis: ["Apple", "Brain"],
                banned_emojis: ["Egg", "Cake", "Potato"],
                correct_definition: "Interesting ideas that help you think about a situation.",
                incorrect_definitions: ["Expression for food you take home from a restaurant.", "To put pressure on someone."],
                sentence: "The experts gave lots of new ideas on the topic, which was certainly ____ .",
                correct_idiom: "food for thought",
                incorrect_idioms: ["a lucky dog", "at the drop of a hat"]
            }, {
                name: "A lucky dog",
                emojis: ["Shamrock", "Dog"],
                banned_emojis: [],
                correct_definition: "A lucky person.",
                incorrect_definitions: ["To have extra spending money.", "A very dependable and unpretentious person."],
                sentence: "Alma always wins the raffle. She is a ____ !",
                correct_idiom: "lucky dog",
                incorrect_idioms: ["feather in her cap", "food for thought"]
            }
        ], [
            {
                name: "Take a rain check",
                emojis: ["StormCloud", "CheckMark"],
                banned_emojis: ["WaterDrop"],
                correct_definition: "To agree to do something at a later date.",
                incorrect_definitions: ["To talk about something in a straightforward manner.", "To put pressure on someone."],
                sentence: "Mylo was too tired to stay for dinner. He told his hosts that he would ____ , and come back another time.",
                correct_idiom: "take a rain check",
                incorrect_idioms: ["turn up the heat", "see the light"]
            }, {
                name: "Light as a feather",
                emojis: ["Sun", "Feather"],
                banned_emojis: [],
                correct_definition: "Something that is extremely light.",
                incorrect_definitions: ["Slang for an experienced sailor.", "To put pressure on someone."],
                sentence: "Even though the box is big, it is easy to carry. It's actually ____ .",
                correct_idiom: "light as a feather",
                incorrect_idioms: ["money to burn", "salt of the earth"]
            }
        ], [
            {
                name: "Seeing eye to eye ",
                emojis: ["Eye", "Eye"],
                banned_emojis: ["CryingEye"],
                correct_definition: "To agree.",
                incorrect_definitions: ["Simplified.", "A meeting in which a group of people share ideas."],
                sentence: "The two friends get along very well, and usually ____ .",
                correct_idiom: "see eye to eye",
                incorrect_idioms: ["brainstorm", "doggy bag"]
            }, {
                name: "Watered down",
                emojis: ["WaterDrop", "DownArrow"],
                banned_emojis: [],
                correct_definition: "Simplified.",
                incorrect_definitions: ["To agree.", "A headache you get when you quickly eat something very cold."],
                sentence: "The teacher gave a simplified, or ____ , version of the complicated history lesson.",
                correct_idiom: "watered down",
                incorrect_idioms: ["doggy bag", "under the table"]
            }, {
                name: "Speak your mind",
                emojis: ["Speak", "Brain"],
                banned_emojis: ["OpenMouth", "MouthWithTongue"],
                correct_definition: "To express one's thoughts.",
                incorrect_definitions: ["Expression for food you take home from a restaurant.", "To agree."],
                sentence: "Never be afraid to ____ during a meeting; your opinion is very important!",
                correct_idiom: "speak your mind",
                incorrect_idioms: ["crocodile smile", "brainfreeze"]
            }, {
                name: "Doggy Bag",
                emojis: ["Dog", "Bag"],
                banned_emojis: [],
                correct_definition: "Expression for food you take home from a restaurant.",
                incorrect_definitions: ["To do something secretly.", "To begin thinking very hard about something."],
                sentence: "I couldn't finish my meal at the restaurant so I asked the server to give me a ____ .",
                correct_idiom: "doggy bag",
                incorrect_idioms: ["brainstorm", "crocodile smile"]
            }, {
                name: "Under the table",
                emojis: ["DownArrow", "Table"],
                banned_emojis: [],
                correct_definition: "To do something secretly.",
                incorrect_definitions: ["To begin thinking very hard about something.", "Expression for food you take home from a restaurant."],
                sentence: "The dishonest mayor makes a lot of secret promises. He prefers to do deals that are ____ .",
                correct_idiom: "under the table",
                incorrect_idioms: ["watered down", "right as rain"]
            }, {
                name: "Put your thinking cap on",
                emojis: ["Brain", "Hat"],
                banned_emojis: [],
                correct_definition: "To begin thinking very hard about something.",
                incorrect_definitions: ["To do something secretly.", "To agree."],
                sentence: "If you just ____ , you'll be sure to come up with a solution.",
                correct_idiom: "put your thinking cap on",
                incorrect_idioms: ["brainfreeze", "doggy bag"]
            }, {
                name: "Right as rain",
                emojis: ["TurnSign", "WaterDrop"],
                banned_emojis: ["StormCloud"],
                correct_definition: "To be perfectly correct.",
                incorrect_definitions: ["A fake smile.", "An idea that is worth thinking about."],
                sentence: "The student got an A+ on her essay. Her argument was ____ .",
                correct_idiom: "right as rain",
                incorrect_idioms: ["a doggy bag", "under the table"]
            }, {
                name: "Crocodile smile",
                emojis: ["Crocodile", "MouthWithTongue"],
                banned_emojis: ["OpenMouth"],
                correct_definition: "A fake smile.",
                incorrect_definitions: ["An idea that is worth thinking about.", "To do something secretly."],
                sentence: "Even though the mean teacher seemed happy, the students knew his smile was actually a ____ .",
                correct_idiom: "crocodile smile",
                incorrect_idioms: ["brainstorm", "doggy bag"]
            }, {
                name: "Brainfreeze",
                emojis: ["Brain", "Snowflake"],
                banned_emojis: [],
                correct_definition: "A headache you get when you quickly eat something very cold.",
                incorrect_definitions: ["A way of saying goodbye for now.", "To put pressure on someone."],
                sentence: "Melia drank her milkshake way too fast and then had a ____ .",
                correct_idiom: "brainfreeze",
                incorrect_idioms: ["brainstorm", "crocodile smile"]
            }
        ]
    ]
}

export const LocalizationGameData = {
  'en-AU': {
    right: [
      "Sweet!{happy}",
    ],
    groups: [
      [
        {
          name: "The best of both worlds",
          emojis: ["Trophy", "Earth"],
          banned_emojis: [],
          correct_definition: "To enjoy the benefits of different situations at the same time.",
          incorrect_definitions: ["Used to observe that time seems to pass very quickly.", "To be upset about something that cannot be changed, or that is not really a big deal."],
          sentence: "Grandma always lives in nice weather: she spends her summers in South Australia and her winters in Queensland. She has ____ .",
          correct_idiom: "the best of both worlds",
          incorrect_idioms: ["raining cats and dogs", "crying over spilt milk"]
        }, {
          name: "Raining cats and dogs",
          emojis: ["StormCloud", "Cat", "Dog"],
          banned_emojis: ["WaterDrop"],
          correct_definition: "To be raining unusually hard.",
          incorrect_definitions: ["When someone has nothing to say.", "To be upset about something that cannot be changed, or that is not really a big deal."],
          sentence: "I have to find my gumboots before I go outside. It's ____ .",
          correct_idiom: "raining cats and dogs",
          incorrect_idioms: ["the cat's meow", "under the weather"]
        }, {
          name: "The cat's meow",
          emojis: ["Cat", "Speak"],
          banned_emojis: ["OpenMouth", "MouthWithTongue"],
          correct_definition: "An excellent person or thing.",
          incorrect_definitions: ["To have a short, light sleep; to doze.", "When someone has nothing to say."],
          sentence: "I love long weekends. They are the ____ .",
          correct_idiom: "cat's meow",
          incorrect_idioms: ["time flies", "raining cats and dogs"]
        }, {
          name: "The cat's pyjamas",
          emojis: ["Cat", "Pajamas"],
          banned_emojis: ["Sleep"],
          correct_definition: "An excellent person or thing.",
          incorrect_definitions: ["To have a short, light sleep; to doze.", "When someone has nothing to say."],
          sentence: "Jen loves her fancy new bike. She thinks it's the ____ .",
          correct_idiom: "cat's pyjamas",
          incorrect_idioms: ["time flies", "cat nap"]
        }, {
          name: "Cat got your tongue",
          emojis: ["Cat", "MouthWithTongue"],
          banned_emojis: ["OpenMouth"],
          correct_definition: "When you have nothing to say.",
          incorrect_definitions: ["To have a short, light sleep; to doze.", "To be unwell or in low spirits."],
          sentence: "You are not talking a lot today. Did the ____ ?",
          correct_idiom: "cat get your tongue",
          incorrect_idioms: ["the cat's pyjamas", "the best of both worlds"]
        }
      ],
      [
        {
          name: "Hot potato ",
          emojis: ["Flame", "Potato"],
          banned_emojis: ["Sun"],
          correct_definition: "A controversial issue or situation; an argument.",
          incorrect_definitions: ["To be nervous about something and want to avoid it.", "Faking tears when you are not actually upset."],
          sentence: "The kids could not agree which movie to watch. The argument was a real ____ .",
          correct_idiom: "hot potato",
          incorrect_idioms: ["bird's eye view", "cold feet"]
        }, {
          name: "You can't have your cake and eat it too",
          emojis: ["Cake", "OpenMouth"],
          banned_emojis: ["Fork", "MouthWithTongue"],
          correct_definition: "Used to say that you cannot do or have two good things at the same time.",
          incorrect_definitions: ["You shouldn't decide the value of something by its outward appearance.", "Everyone will have good luck or success at some point in their lives."],
          sentence: "Adam doesn't want to study but he wants high marks. His mother says ____ .",
          correct_idiom: "he can't have his cake and eat it too",
          incorrect_idioms: ["to go cold turkey", "time is money"]
        }
      ],
      [
        {
          name: "To be in hot water",
          emojis: ["Flame", "WaterDrop"],
          banned_emojis: ["Sun"],
          correct_definition: "To be in trouble.",
          incorrect_definitions: ["To refuse or criticise a gift.", "To have extra spending money."],
          sentence: "When the kids were called to the principal's office, they knew they were ____ .",
          correct_idiom: "in hot water",
          incorrect_idioms: ["hot potato", "crocodile tears"]
        }, {
          name: "The dog days of summer",
          emojis: ["Dog", "Date", "Sun"],
          banned_emojis: [],
          correct_definition: "Very hot days.",
          incorrect_definitions: ["To be in trouble.", "To refuse or criticise a gift."],
          sentence: "I like to cool off in the pool in the month of January, during the ____ .",
          correct_idiom: "dog days of summer",
          incorrect_idioms: ["hot potato", "cold feet"]
        }
      ],
      [
        {
          name: "To turn up the heat",
          emojis: ["TurnSign", "UpArrow", "Flame"],
          banned_emojis: ["Sun"],
          correct_definition: "To put pressure on someone.",
          incorrect_definitions: ["To do something perfectly.", "Something that is extremely light."],
          sentence: "The competition was tough in the second half of the match. They really ____ .",
          correct_idiom: "turned up the heat",
          incorrect_idioms: ["had money to burn", "took a rain check"]
        },
        {
          name: "With flying colours",
          emojis: ["Wings", "PaintPalette"],
          banned_emojis: [],
          correct_definition: "To do something perfectly.",
          incorrect_definitions: ["A way of saying goodbye for now.", "Something that is extremely light."],
          sentence: "Graham got an A+ on his exam! He passed ____ .",
          correct_idiom: "with flying colours",
          incorrect_idioms: ["light as a feather", "a sea dog"]
        }, {
          name: "See you later, alligator",
          emojis: ["Eye", "Clock", "Crocodile"],
          banned_emojis: ["Date", "CryingEye"],
          correct_definition: "A way of saying goodbye for now.",
          incorrect_definitions: ["A meeting in which a group of people share ideas.", "To agree."],
          sentence: "As Katherine walked out the door, she turned around and said ____",
          correct_idiom: "'See you later, alligator!'",
          incorrect_idioms: ["'Money to burn!'", "'Salt of the earth!'"]
        }
      ],
      [
      ]
    ]
  },
  'en-CA': {
    right: [
      "Sweet!{happy}",
    ],
    groups: [
      [
        {
          name: "The best of both worlds",
          emojis: ["Trophy", "Earth"],
          banned_emojis: [],
          correct_definition: "To enjoy the benefits of different situations at the same time.",
          incorrect_definitions: ["Used to observe that time seems to pass very quickly.", "To be upset about something that cannot be changed, or that is not really a big deal."],
          sentence: "Grandma always lives in nice weather: she spends her summers in Vancouver and her winters in Mexico. She has ____ .",
          correct_idiom: "the best of both worlds",
          incorrect_idioms: ["raining cats and dogs", "crying over spilt milk"]
        }
      ],
      [
      ],
      [
      ],
      [
        {
          name: "With flying colours",
          emojis: ["Wings", "PaintPalette"],
          banned_emojis: [],
          correct_definition: "To do something perfectly.",
          incorrect_definitions: ["A way of saying goodbye for now.", "Something that is extremely light."],
          sentence: "Graham got an A+ on his test! He passed ____ .",
          correct_idiom: "with flying colours",
          incorrect_idioms: ["light as a feather", "a salty dog"]
        }
      ],
      [
      ]
    ]
  },
  'en-GB': {
    right: [
      "Great!{happy}",
    ],
    groups: [
      [
        {
          name: "The best of both worlds",
          emojis: ["Trophy", "Earth"],
          banned_emojis: [],
          correct_definition: "To enjoy the benefits of different situations at the same time.",
          incorrect_definitions: ["Used to observe that time seems to pass very quickly.", "To be upset about something that cannot be changed, or that is not really a big deal."],
          sentence: "Grandma always lives in nice weather: she spends her summers in Spain and her winters in South Africa. She has ____ .",
          correct_idiom: "the best of both worlds",
          incorrect_idioms: ["raining cats and dogs", "crying over spilt milk"]
        }, {
          name: "Raining cats and dogs",
          emojis: ["StormCloud", "Cat", "Dog"],
          banned_emojis: ["WaterDrop"],
          correct_definition: "To be raining unusually hard.",
          incorrect_definitions: ["When someone has nothing to say.", "To be upset about something that cannot be changed, or that is not really a big deal."],
          sentence: "I have to find my wellies before I go outside. It's ____ .",
          correct_idiom: "raining cats and dogs",
          incorrect_idioms: ["the cat's whiskers", "under the weather"]
        }, {
          name: "Cat got your tongue",
          emojis: ["Cat", "MouthWithTongue"],
          banned_emojis: ["OpenMouth"],
          correct_definition: "When you have nothing to say.",
          incorrect_definitions: ["To have a short, light sleep; to doze.", "To be unwell or in low spirits."],
          sentence: "You are not talking a lot today. Did the ____ ?",
          correct_idiom: "cat get your tongue",
          incorrect_idioms: ["the cat's whiskers", "the best of both worlds"]
        }, {
          name: "The cat's whiskers",
          emojis: ["Cat"],
          banned_emojis: ["Sleep"],
          correct_definition: "An excellent person or thing.",
          incorrect_definitions: ["To have a short, light sleep; to doze.", "When someone has nothing to say."],
          sentence: "Jen loves her fancy new bike. She thinks it's the ____ .",
          correct_idiom: "cat's whiskers",
          incorrect_idioms: ["time flies", "cat nap"]
        } 
      ],
      [
        {
          name: "You can't have your cake and eat it too",
          emojis: ["Cake", "OpenMouth"],
          banned_emojis: ["Fork", "MouthWithTongue"],
          correct_definition: "Used to say that you cannot do or have two good things at the same time.",
          incorrect_definitions: ["You shouldn't decide the value of something by its outward appearance.", "Everyone will have good luck or success at some point in their lives."],
          sentence: "Adam doesn't want to study but he wants good grades. His mother says ____ .",
          correct_idiom: "he can't have his cake and eat it too",
          incorrect_idioms: ["to go cold turkey", "time is money"]
        }
      ],
      [
        {
          name: "The dog days of summer",
          emojis: ["Dog", "Date", "Sun"],
          banned_emojis: [],
          correct_definition: "Very hot days.",
          incorrect_definitions: ["To be in trouble.", "To refuse or criticise a gift."],
          sentence: "I like to cool off in the pool in the month of August, during the ____ .",
          correct_idiom: "dog days of summer",
          incorrect_idioms: ["hot potato", "cold feet"]
        }, {
          name: "Hot potato ",
          emojis: ["Flame", "Potato"],
          banned_emojis: ["Sun"],
          correct_definition: "A controversial issue or situation; an argument.",
          incorrect_definitions: ["To be nervous about something and want to avoid it.", "Faking tears when you are not actually upset."],
          sentence: "The kids could not agree which film to watch. The argument was a real ____ .",
          correct_idiom: "hot potato",
          incorrect_idioms: ["bird's eye view", "cold feet"]
        }, {
          name: "To be in hot water",
          emojis: ["Flame", "WaterDrop"],
          banned_emojis: ["Sun"],
          correct_definition: "To be in trouble.",
          incorrect_definitions: ["To refuse or criticise a gift.", "To have extra spending money."],
          sentence: "When the kids were called to the headmaster's office, they knew they were ____ .",
          correct_idiom: "in hot water",
          incorrect_idioms: ["hot potato", "crocodile tears"]
        }
      ],
      [
        {
          name: "To turn up the heat",
          emojis: ["TurnSign", "UpArrow", "Flame"],
          banned_emojis: ["Sun"],
          correct_definition: "To put pressure on someone.",
          incorrect_definitions: ["To do something perfectly.", "Something that is extremely light."],
          sentence: "The competition was tough in the second half of the game. They really ____ .",
          correct_idiom: "turned up the heat",
          incorrect_idioms: ["had money to burn", "took a rain check"]
        }, {
          name: "With flying colours",
          emojis: ["Wings", "PaintPalette"],
          banned_emojis: [],
          correct_definition: "To do something perfectly.",
          incorrect_definitions: ["A way of saying goodbye for now.", "Something that is extremely light."],
          sentence: "Graham got an A+ on his test! He passed ____ .",
          correct_idiom: "with flying colours",
          incorrect_idioms: ["light as a feather", "a sea dog"]
        }, {
          name: "See you later, alligator",
          emojis: ["Eye", "Clock", "Crocodile"],
          banned_emojis: ["Date", "CryingEye"],
          correct_definition: "A way of saying goodbye for now.",
          incorrect_definitions: ["A meeting in which a group of people share ideas.", "To agree."],
          sentence: "As Katherine walked out the door, she turned around and said ____",
          correct_idiom: "\"See you later, alligator!\"",
          incorrect_idioms: ["\"Money to burn!\"", "\"Salt of the earth!\""]
        }
      ],
      [
      ]
    ]
  },
  'en-US': {
    right: [
      "Sweet!{happy}",
    ],
    groups: [
      [
        {
          name: "Taking a cat nap",
          emojis: ["Cat", "Sleep"],
          banned_emojis: ["Pajamas"],
          correct_definition: "To have a short, light sleep; to doze.",
          incorrect_definitions: ["Used to show enthusiasm about a new idea, person or thing", "To reveal a secret carelessly or by mistake"],
          sentence: "My favorite part of a lazy afternoon is relaxing and ____ .",
          correct_idiom: "taking a cat nap",
          incorrect_idioms: ["crying over spilt milk", "under the weather"]
        }, {
          name: "The best of both worlds",
          emojis: ["Trophy", "Earth"],
          banned_emojis: [],
          correct_definition: "To enjoy the benefits of different situations at the same time.",
          incorrect_definitions: ["Used to observe that time seems to pass very quickly.", "To be upset about something that cannot be changed, or that is not really a big deal."],
          sentence: "Grandma always lives in nice weather: she spends her summers in Maine and her winters in Florida. She has ____ .",
          correct_idiom: "the best of both worlds",
          incorrect_idioms: ["raining cats and dogs", "crying over spilt milk"]
        }
      ],
      [
      ],
      [
        {
          name: "Straight from the horse's mouth",
          emojis: [
            "Horse",
            "OpenMouth"
          ],
          banned_emojis: [
            "MouthWithTongue",
            "Speak"
          ],
          correct_definition: "To get information from the person who said it first.",
          incorrect_definitions: [
            "An achievement to be proud of.",
            "Used to describe a cherished person or thing."
          ],
          sentence: "I knew that the rumors were true, since the information came ____ .",
          correct_idiom: "straight from the horse's mouth",
          incorrect_idioms: [
            "at the drop of a hat",
            "in hot water"
          ]
        }, {
          name: "The apple of one's eye",
          emojis: ["Apple", "Eye"],
          banned_emojis: ["CryingEye"],
          correct_definition: "Used to describe a cherished person or thing.",
          incorrect_definitions: ["Used to describe an event that happens right away, or quickly.", "A view of something from above."],
          sentence: "Richard is his grandmother's favorite grandchild. He is the ____ .",
          correct_idiom: "apple of her eye",
          incorrect_idioms: ["bird's eye view", "hot potato"]
        }
      ],
      [
        {
          name: "Talking turkey",
          emojis: ["Speak", "Turkey"],
          banned_emojis: ["OpenMouth", "MouthWithTongue"],
          correct_definition: "To talk about something in a straightforward manner.",
          incorrect_definitions: ["To put pressure on someone.", "A way of saying goodbye for now."],
          sentence: "There's no time to joke around, so let's get down to business and ____ .",
          correct_idiom: "talk turkey",
          incorrect_idioms: ["take a rain check", "see you later, alligator"]
        }, {
          name: "With flying colors",
          emojis: ["Wings", "PaintPalette"],
          banned_emojis: [],
          correct_definition: "To do something perfectly.",
          incorrect_definitions: ["A way of saying goodbye for now.", "Something that is extremely light."],
          sentence: "Graham got an A+ on his test! He passed ____ .",
          correct_idiom: "with flying colors",
          incorrect_idioms: ["light as a feather", "a salty dog"]
        }
      ],
      [
      ]
    ]
  },
  'en-GB_CA_AU': {
    groups: [
      [
        {
          name: "Taking a cat nap",
          emojis: ["Cat", "Sleep"],
          banned_emojis: ["Pajamas"],
          correct_definition: "To have a short, light sleep; to doze.",
          incorrect_definitions: ["Used to show enthusiasm about a new idea, person or thing", "To reveal a secret carelessly or by mistake"],
          sentence: "My favourite part of a lazy afternoon is relaxing and ____ .",
          correct_idiom: "taking a cat nap",
          incorrect_idioms: ["crying over spilt milk", "under the weather"]
        }
      ],
      [
      ],
      [
        {
          name: "Straight from the horse's mouth",
          emojis: ["Horse", "OpenMouth"],
          banned_emojis: ["MouthWithTongue", "Speak"],
          correct_definition: "To get information from the person who said it first.",
          incorrect_definitions: ["An achievement to be proud of.", "Used to describe a cherished person or thing."],
          sentence: "I knew that the rumours were true, since the information came ____ .",
          correct_idiom: "straight from the horse's mouth",
          incorrect_idioms: ["at the drop of a hat", "in hot water"]
        }, {
          name: "The apple of one's eye",
          emojis: ["Apple", "Eye"],
          banned_emojis: ["CryingEye"],
          correct_definition: "Used to describe a cherished person or thing.",
          incorrect_definitions: ["Used to describe an event that happens right away, or quickly.", "A view of something from above."],
          sentence: "Richard is his grandmother's favourite grandchild. He is the ____ .",
          correct_idiom: "apple of her eye",
          incorrect_idioms: ["bird's eye view", "hot potato"]
        }
      ],
      [
      ],
      [
      ]
    ]
  },
  'en-CA_US': {
    groups: [
      [
        {
          name: "The cat's meow",
          emojis: ["Cat", "Speak"],
          banned_emojis: ["OpenMouth", "MouthWithTongue"],
          correct_definition: "An excellent person or thing.",
          incorrect_definitions: ["To have a short, light sleep; to doze.", "When someone has nothing to say."],
          sentence: "I love long weekends. They are the ____ .",
          correct_idiom: "cat's meow",
          incorrect_idioms: ["time flies", "raining cats and dogs"]
        }, {
          name: "Raining cats and dogs",
          emojis: ["StormCloud", "Cat", "Dog"],
          banned_emojis: ["WaterDrop"],
          correct_definition: "To be raining unusually hard.",
          incorrect_definitions: ["When someone has nothing to say.", "To be upset about something that cannot be changed, or that is not really a big deal."],
          sentence: "I have to find my rain boots before I go outside. It's ____ .",
          correct_idiom: "raining cats and dogs",
          incorrect_idioms: ["the cat's meow", "under the weather"]
        }, {
          name: "The cat's pajamas",
          emojis: ["Cat", "Pajamas"],
          banned_emojis: ["Sleep"],
          correct_definition: "An excellent person or thing.",
          incorrect_definitions: ["To have a short, light sleep; to doze.", "When someone has nothing to say."],
          sentence: "Jen loves her fancy new bike. She thinks it's the ____ .",
          correct_idiom: "cat's pajamas",
          incorrect_idioms: ["time flies", "cat nap"]
        }, {
          name: "Cat got your tongue",
          emojis: ["Cat", "MouthWithTongue"],
          banned_emojis: ["OpenMouth"],
          correct_definition: "When you have nothing to say.",
          incorrect_definitions: ["To have a short, light sleep; to doze.", "To be unwell or in low spirits."],
          sentence: "You are not talking a lot today. Did the ____ ?",
          correct_idiom: "cat get your tongue",
          incorrect_idioms: ["the cat's pajamas", "the best of both worlds"]
        } 
      ],
      [
        {
          name: "Every dog has its day",
          emojis: ["Dog", "Date"],
          banned_emojis: ["Clock"],
          correct_definition: "Everyone will have good luck or success at some point in their lives.",
          incorrect_definitions: ["Avoid interfering in a situation that is currently causing no problems.", "Time is a valuable resource, therefore it is better to do things as quickly as possible."],
          sentence: "Isabella did not do well in the lacrosse game, but is still hopeful. She knows that ____ .",
          correct_idiom: "every dog has its day",
          incorrect_idioms: ["to be a fish out of water", "to go cold turkey"]
        }, {
          name: "Time is money",
          emojis: ["Clock", "Dollar"],
          banned_emojis: ["Date"],
          correct_definition: "Time is a valuable resource, therefore it is better to do things as quickly as possible.",
          incorrect_definitions: ["To withdraw suddenly and completely from something you are dependent on.", "To call for help when it is not needed."],
          sentence: "My mom likes to stay busy and productive, and often reminds me that ____ !",
          correct_idiom: "time is money",
          incorrect_idioms: ["to cry wolf", "to let sleeping dogs lie"]
        }, {
          name: "You can't have your cake and eat it too",
          emojis: ["Cake", "OpenMouth"],
          banned_emojis: ["Fork", "MouthWithTongue"],
          correct_definition: "Used to say that you cannot do or have two good things at the same time.",
          incorrect_definitions: ["You shouldn't decide the value of something by its outward appearance.", "Everyone will have good luck or success at some point in their lives."],
          sentence: "Adam doesn't want to study but he wants good grades. His mother says ____ .",
          correct_idiom: "he can't have his cake and eat it too",
          incorrect_idioms: ["to go cold turkey", "time is money"]
        } 
      ],
      [
        {
          name: "The dog days of summer",
          emojis: ["Dog", "Date", "Sun"],
          banned_emojis: [],
          correct_definition: "Very hot days.",
          incorrect_definitions: ["To be in trouble.", "To refuse or criticize a gift."],
          sentence: "I like to cool off in the pool in the month of August, during the ____ .",
          correct_idiom: "dog days of summer",
          incorrect_idioms: ["hot potato", "cold feet"]
        }, {
          name: "To be in hot water",
          emojis: ["Flame", "WaterDrop"],
          banned_emojis: ["Sun"],
          correct_definition: "To be in trouble.",
          incorrect_definitions: ["To refuse or criticize a gift.", "To have extra spending money."],
          sentence: "When the kids were called to the principal's office, they knew they were ____ .",
          correct_idiom: "in hot water",
          incorrect_idioms: ["hot potato", "crocodile tears"]
        }, {
          name: "Look a gift horse in the mouth",
          emojis: ["Gift", "Horse", "OpenMouth"],
          banned_emojis: ["MouthWithTongue", "Eye"],
          correct_definition: "To refuse or criticize a gift.",
          incorrect_definitions: ["A lucky person.", "To have extra spending money."],
          sentence: "Even though Livia did not like the present, she thanked her aunt. She knows not to ____ .",
          correct_idiom: "look a gift horse in the mouth",
          incorrect_idioms: ["straight from the horse's mouth", "have cold feet"]
        }, {
          name: "Hot potato ",
          emojis: ["Flame", "Potato"],
          banned_emojis: ["Sun"],
          correct_definition: "A controversial issue or situation; an argument.",
          incorrect_definitions: ["To be nervous about something and want to avoid it.", "Faking tears when you are not actually upset."],
          sentence: "The kids could not agree which movie to watch. The argument was a real ____ .",
          correct_idiom: "hot potato",
          incorrect_idioms: ["bird's eye view", "cold feet"]
        }
      ],
      [
        {
          name: "Money to burn",
          emojis: ["Dollar", "Flame"],
          banned_emojis: [],
          correct_definition: "To have extra spending money.",
          incorrect_definitions: ["To talk about something in a straightforward manner.", "To understand something."],
          sentence: "Mr. Santiago spent too much money on his new car. He must have ____ .",
          correct_idiom: "money to burn",
          incorrect_idioms: ["the salt of the earth", "a salty dog"]
        }, {
          name: "To see the light",
          emojis: ["Eye", "Sun"],
          banned_emojis: ["CryingEye"],
          correct_definition: "To understand something.",
          incorrect_definitions: ["To agree to do something at a later date.", "To talk about something in a straightforward manner."],
          sentence: "After weeks of studying my math problems, I finally understood. My hard work helped me to ____ .",
          correct_idiom: "see the light",
          incorrect_idioms: ["take a rain check", "turn up the heat"]
        }, {
          name: "To turn up the heat",
          emojis: ["TurnSign", "UpArrow", "Flame"],
          banned_emojis: ["Sun"],
          correct_definition: "To put pressure on someone.",
          incorrect_definitions: ["To do something perfectly.", "Something that is extremely light."],
          sentence: "The competition was tough in the second half of the game. They really ____ .",
          correct_idiom: "turned up the heat",
          incorrect_idioms: ["had money to burn", "took a rain check"]
        }, {
          name: "See you later, alligator",
          emojis: ["Eye", "Clock", "Crocodile"],
          banned_emojis: ["Date", "CryingEye"],
          correct_definition: "A way of saying goodbye for now.",
          incorrect_definitions: ["A meeting in which a group of people share ideas.", "To agree."],
          sentence: "As Katherine walked out the door, she turned around and said ____",
          correct_idiom: "\"See you later, alligator!\"",
          incorrect_idioms: ["\"Money to burn!\"", "\"Salt of the earth!\""]
        }, {
          name: "Salty dog",
          emojis: ["Salt", "Dog"],
          banned_emojis: [],
          correct_definition: "Slang for an experienced sailor.",
          incorrect_definitions: ["A headache you get when you quickly eat something very cold.", "Something that is extremely light."],
          sentence: "The older woman had been sailing for more than 40 years. She was a real ____ .",
          correct_idiom: "salty dog",
          incorrect_idioms: ["light as a feather", "salt of the earth"]
        },             {
          name: "Salt of the Earth",
          emojis: ["Salt", "Earth"],
          banned_emojis: [],
          correct_definition: "Used to describe a very good person.",
          incorrect_definitions: ["To understand something.", "To agree to do something at a later date."],
          sentence: "Even though she is a busy career woman, she always has time to help a friend. She is the ____ .",
          correct_idiom: "salt of the earth",
          incorrect_idioms: ["light as a feather", "a salty dog"]
        } 
      ],
      [
        {
          name: "Brainstorm",
          emojis: ["Brain", "StormCloud"],
          banned_emojis: [""],
          correct_definition: "A meeting in which a group of people share ideas.",
          incorrect_definitions: ["A headache you get when you quickly eat something very cold.", "To refuse or criticize a gift."],
          sentence: "The team of designers met in the conference room to ____ , and come up with a new game.",
          correct_idiom: "brainstorm",
          incorrect_idioms: ["brainfreeze", "right as rain"]
        }
      ]
    ]
  },
  'en-GB_AU': {
    groups: [
      [
      ],
      [
        {
          name: "Every dog has its day",
          emojis: ["Dog", "Date"],
          banned_emojis: ["Clock"],
          correct_definition: "Everyone will have good luck or success at some point in their lives.",
          incorrect_definitions: ["Avoid interfering in a situation that is currently causing no problems.", "Time is a valuable resource, therefore it is better to do things as quickly as possible."],
          sentence: "Isabella did not do well in the netball game, but is still hopeful. She knows that ___ .",
          correct_idiom: "every dog has its day",
          incorrect_idioms: ["to be a fish out of water", "to go cold turkey"]
        }, {
          name: "Time is money",
          emojis: ["Clock", "Dollar"],
          banned_emojis: ["Date"],
          correct_definition: "Time is a valuable resource, therefore it is better to do things as quickly as possible.",
          incorrect_definitions: ["To withdraw suddenly and completely from something you are dependent on.", "To call for help when it is not needed."],
          sentence: "My mum likes to stay busy and productive, and often reminds me that ____ !",
          correct_idiom: "time is money",
          incorrect_idioms: ["to cry wolf", "to let sleeping dogs lie"]
        } 
      ],
      [
        {
          name: "Look a gift horse in the mouth",
          emojis: ["Gift", "Horse", "OpenMouth"],
          banned_emojis: ["MouthWithTongue", "Eye"],
          correct_definition: "To refuse or criticise a gift.",
          incorrect_definitions: ["A lucky person.", "To have extra spending money."],
          sentence: "Even though Livia did not like the present, she thanked her aunt. She knows not to ____ .",
          correct_idiom: "look a gift horse in the mouth",
          incorrect_idioms: ["straight from the horse's mouth", "have cold feet"]
        }
      ],
      [
        {
          name: "Money to burn",
          emojis: ["Dollar", "Flame"],
          banned_emojis: [],
          correct_definition: "To have extra spending money.",
          incorrect_definitions: ["To talk about something in a straightforward manner.", "To understand something."],
          sentence: "Mr Santiago spent too much money on his new car. He must have ____ .",
          correct_idiom: "money to burn",
          incorrect_idioms: ["the salt of the earth", "a sea dog"]
        }, {
          name: "To see the light",
          emojis: ["Eye", "Sun"],
          banned_emojis: ["CryingEye"],
          correct_definition: "To understand something.",
          incorrect_definitions: ["To agree to do something at a later date.", "To talk about something in a straightforward manner."],
          sentence: "After weeks of studying my maths problems, I finally understood. My hard work helped me to ____ .",
          correct_idiom: "see the light",
          incorrect_idioms: ["take a rain check", "turn up the heat"]
        }, {
          name: "Sea dog",
          emojis: ["Eye", "Dog"],
          banned_emojis: [],
          correct_definition: "Slang for an experienced sailor.",
          incorrect_definitions: ["A headache you get when you quickly eat something very cold.", "Something that is extremely light."],
          sentence: "The older woman had been sailing for more than 40 years. She was a real ____ .",
          correct_idiom: "sea dog",
          incorrect_idioms: ["light as a feather", "salt of the earth"]
        }, {
          name: "Salt of the Earth",
          emojis: ["Salt", "Earth"],
          banned_emojis: [],
          correct_definition: "Used to describe a very good person.",
          incorrect_definitions: ["To understand something.", "To agree to do something at a later date."],
          sentence: "Even though she is a busy career woman, she always has time to help a friend. She is the ____ .",
          correct_idiom: "salt of the earth",
          incorrect_idioms: ["light as a feather", "a sea dog"]
      }  
      ],
      [
        {
          name: "Brainstorm",
          emojis: ["Brain", "StormCloud"],
          banned_emojis: [""],
          correct_definition: "A meeting in which a group of people share ideas.",
          incorrect_definitions: ["A headache you get when you quickly eat something very cold.", "To refuse or criticise a gift."],
          sentence: "The team of designers met in the conference room to ____ , and come up with a new game.",
          correct_idiom: "brainstorm",
          incorrect_idioms: ["brainfreeze", "right as rain"]
        }
      ]
    ]
  }

};